import React, { useState, useEffect } from "react";
import Toolbar from "../../navigation/mobile/Toolbar";
import Footer from "../../layout/mobile/Footer";
import MobileHeader from "../../layout/mobile/MobileHeader";
import { Modal } from 'react-bootstrap';
import NoData from "../../common/mobile/NoData";

function MobilePromotion({promotions}) {
  const [loading, setLoading] = useState(true);
  const [selectedPromotion, setSelectedPromotion] = useState(null); 
  const [showModal, setShowModal] = useState(false); 
  const [loadingDetails, setLoadingDetails] = useState(false);



  // Function to handle modal open
  const handleShowModal = async (promotionId) => {
      setLoadingDetails(true); // Start loading details
      try {
          const response = await fetch(`${process.env.REACT_APP_API_URL}/api/promotions/${promotionId}`);
          if (!response.ok) {
              throw new Error("Failed to fetch promotion details");
          }
          const promotionDetails = await response.json();
          setSelectedPromotion(promotionDetails); // Set the selected promotion
      } catch (error) {
          console.error("Error fetching promotion details:", error);
      } finally {
          setLoadingDetails(false); // Stop loading details
          setShowModal(true); // Show the modal
      }
  };

  // Function to handle modal close
  const handleCloseModal = () => {
      setShowModal(false);
      setSelectedPromotion(null); 
  };

  

  return (
      <div className="main-router-wrapper">
          <MobileHeader />
          <div className="wrap">
              <div className="content">
                  <div className="content-main">
                      <div className="content-box">
                          <div className="promotion">
                              <div className="tab search-tab">
                                  <ul className="item-ani">
                                      <li className="active">ALL</li>
                                      <li>Welcome Offer</li>
                                      <li>Slots</li>
                                      <li>Live Casino</li>
                                      <li>Sports</li>
                                      <li>Fishing</li>
                                      <li>E-sports</li>
                                      <li>Lottery</li>
                                      <li>P2P</li>
                                      <li>Table</li>
                                      <li>Arcade</li>
                                      <li>Crash</li>
                                      <li>Others</li>
                                  </ul>
                              </div>
                              <div className="promotion-main">
                                  {promotions.length > 0 ? (
                                      promotions.map((promotion) => (
                                          <div className="promotion-box new" key={promotion.id}>
                                              <div className="pic">
                                                  <img src={`${process.env.REACT_APP_API_URL}/storage/${promotion.thumbnail}`} alt={promotion.name} loading="lazy" />
                                                  <span className="item-bg" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/player/promotion-bg.svg")' }} />
                                              </div>
                                              <div className="promotion-box-inner content-style">
                                                  <div className="text-main">
                                                      <h3>{promotion.name}</h3>
                                                      <p>{promotion.desc ? promotion.desc.split(' ').slice(0, 5).join(' ') : 'No description available'}</p>
                                                  </div>
                                                  <div className="times">
                                                      <span className="item-icon" style={{ maskImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-clock.svg")' }} />
                                                      <span>{` Start: ${new Date(promotion.start_date).toLocaleDateString('en-GB')} ~ End: ${new Date(promotion.end_date).toLocaleDateString('en-GB')}`}</span>
                                                  </div>
                                                  <div className="button-box">
                                                      <div onClick={() => handleShowModal(promotion.id)} className="button btn-primary"><span>Details</span></div>
                                                  </div>
                                              </div>
                                          </div>
                                      ))
                                  ) : (
                                      <NoData/>
                                  )}
                                  <div className="prompt">－end of page－</div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <Footer />
          </div>
          <Toolbar />
          {showModal && (
            <div className="cdk-overlay-container">
                <div onClick={handleCloseModal} className="cdk-overlay-backdrop dialog-backdrop cdk-overlay-backdrop-showing" />
                <div className="cdk-global-overlay-wrapper" dir="ltr" style={{justifyContent: 'center', alignItems: 'center'}}>
                    <div id="cdk-overlay-3" className="cdk-overlay-pane dialog-panel" style={{position: 'static'}}>
                    <div  className="popup" id="dialog-3">
                        <div  className="popup__header" />
                        <div  className="popup__content">
                        <div className="pop-wrap promotion-pop new  ng-trigger ng-trigger-popWrapTriggerAni ani show ng-star-inserted">
                            <a onClick={handleCloseModal} className="btn-close">

                            <span className="item-icon " style={{backgroundImage: 'url("https://img.j189eb.com/jb/h5/assets/images/icon-set/icon-cross-type01.svg?v=1751079404561")'}} />
                            </a>
                            <div className="detail-banner  ng-star-inserted" style={{}}>
                            <img className="" src={`${process.env.REACT_APP_API_URL}/storage/${selectedPromotion.thumbnail}`} alt={selectedPromotion.name} loading="lazy" />
                            </div>
                            <div className="pop-title  ng-star-inserted" style={{}}>
                            <h3 className="">{selectedPromotion ? selectedPromotion.name : ''}</h3>
                            </div>
                            <div className="pop-inner content-style  ng-star-inserted" style={{}}>
                            <div className="">
                                <p dir="ltr" style={{lineHeight: '1.38', marginTop: '0pt', marginBottom: '0pt'}}>
                                <b id="docs-internal-guid-43bfb98b-7fff-f42a-f8ab-169c7165ef6d" style={{fontWeight: 'normal'}}>
                                    <span style={{fontSize: '11pt', fontFamily: 'Arial, sans-serif', fontWeight: 400, fontStyle: 'normal', fontVariant: 'normal', textDecoration: 'none', verticalAlign: 'baseline', whiteSpace: 'pre-wrap'}}>
                                    {selectedPromotion.desc}
                                    </span>
                                </b>

                                </p>
                            
                            
                            </div>
                            </div>
                        
                        </div>
                        
                        <div className="pop-bg ng-trigger ng-trigger-popBgTriggerAni  ng-star-inserted" style={{display: 'block'}} />
                        
                        </div>
                    </div>
                    </div>
                </div>
                </div>

          )}
      </div>
  );
}

export default MobilePromotion;
